import { setCropModeElementUuidAction } from 'editor/src/store/editor/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import setFocusedMediaElementUuidOperation from './setFocusedMediaElementUuidOperation';

const startCropModeOperation = (uuid: number) => (dispatch: ThunkDispatch) => {
  dispatch(setCropModeElementUuidAction(uuid));
  dispatch(setFocusedMediaElementUuidOperation(uuid));
};

export default startCropModeOperation;
